import axiosConfig from '../../../../../redux/Spoolsbase/axiosConfig';

export const SPOOL_FAT_PATH = '/spool-tracker/fat';

export type SpoolFatPanelDto = {
  id: number;
  projectId: number;
  pipeId: number;
  spoolId: number;
  submissionMode: string;
  payload: object | null;
  updatedAt: string | null;
};

function unwrap<T>(res: { data?: unknown }): T {
  const d = res?.data;
  if (d && typeof d === 'object' && 'data' in d) {
    return (d as { data: T }).data as T;
  }
  return d as T;
}

/**
 * GET /spool-tracker/fat?project_id=&pipe_id=&spool_id=
 */
export async function getSpoolFat(params: {
  projectId: string | number;
  pipeId: string | number;
  spoolId: string | number;
}): Promise<{ projectId: number; pipeId: number; spoolId: number; fat: SpoolFatPanelDto | null }> {
  const { data } = await axiosConfig.get(SPOOL_FAT_PATH, {
    params: {
      project_id: params.projectId,
      pipe_id: params.pipeId,
      spool_id: params.spoolId,
    },
  });
  return unwrap<{
    projectId: number;
    pipeId: number;
    spoolId: number;
    fat: SpoolFatPanelDto | null;
  }>({ data } as { data: unknown });
}

/**
 * POST /spool-tracker/fat
 */
export async function saveSpoolFat(body: {
  projectId: string | number;
  pipeId: string | number;
  spoolId: string | number;
  submissionMode?: string;
  payload: object | null;
}): Promise<{
  id: number;
  projectId: number;
  pipeId: number;
  spoolId: number;
  submissionMode: string;
  payload: object | null;
  updatedAt: string | null;
  fat: { done: number; total: number };
}> {
  const { data } = await axiosConfig.post(SPOOL_FAT_PATH, {
    projectId: body.projectId,
    pipeId: body.pipeId,
    spoolId: body.spoolId,
    submissionMode: body.submissionMode ?? 'draft',
    payload: body.payload,
  });
  return unwrap<{
    id: number;
    projectId: number;
    pipeId: number;
    spoolId: number;
    submissionMode: string;
    payload: object | null;
    updatedAt: string | null;
    fat: { done: number; total: number };
  }>({ data } as { data: unknown });
}
